export const EmbedRoutes = [
  { path: 'calendar', lazy: () => import('./pages/embed.$oid.calendar'), },
  { path: 'festivals/:pid/calendar', lazy: () => import('./pages/embed.$oid.festivals.$pid.calendar'), },
]
